/**
 * Localized catalogue / session exercise labels for planning & cards.
 */
import { normalizeAppLang } from "./appLanguages";

const LOCALE_KEYS = ["en", "fr", "de", "es", "nl", "pt"];

export function catalogLang(raw) {
  return normalizeAppLang(raw);
}

/**
 * Prefer the UI language field, then other locales, then legacy `ex_name` / `name`.
 * Never prefer an English-only `name` override when a localized field exists.
 */
export function localizedField(obj, prefix, lang) {
  if (!obj || typeof obj !== "object") return "";
  const l = catalogLang(lang);
  const preferred = String(obj[`${prefix}_${l}`] || "").trim();
  if (preferred) return preferred;
  for (const loc of LOCALE_KEYS) {
    if (loc === l) continue;
    const v = String(obj[`${prefix}_${loc}`] || "").trim();
    if (v) return v;
  }
  const legacy = String(obj[prefix] || "").trim();
  if (legacy) return legacy;
  if (prefix === "ex_name") {
    const n = String(obj.name || "").trim();
    if (n) return n;
  }
  return "";
}

export function localizedExerciseName(ex, lang) {
  if (!ex) return "";
  return (
    localizedField(ex, "ex_name", lang) ||
    localizedField(ex.exercise, "ex_name", lang) ||
    localizedField(ex.tbl_exercise, "ex_name", lang) ||
    localizedField(ex.base_exercise, "ex_name", lang) ||
    ""
  );
}

/**
 * Personalized / Digiping exercise proposals use `draft_name_*` (and sometimes
 * nested `draft.ex_name_*`). Prefer the UI language; never hardcode English first.
 */
export function localizedDraftName(obj, lang) {
  if (!obj) return "";
  return (
    localizedField(obj, "draft_name", lang) ||
    localizedExerciseName(obj, lang) ||
    localizedExerciseName(obj.draft, lang) ||
    localizedField(obj.draft, "draft_name", lang) ||
    ""
  );
}

export function localizedDraftObjective(obj, lang) {
  if (!obj) return "";
  return (
    localizedField(obj, "draft_objective", lang) ||
    localizedField(obj.draft, "draft_objective", lang) ||
    localizedField(obj, "ex_objective", lang) ||
    localizedField(obj.draft, "ex_objective", lang) ||
    ""
  );
}

export function localizedTypeName(typeObj, lang) {
  return localizedField(typeObj, "type_name", lang);
}

export function localizedSubTypeName(subObj, lang) {
  return localizedField(subObj, "sub_type_name", lang);
}

export function localizedCbName(cbObj, lang) {
  return localizedField(cbObj, "cb_name", lang);
}
